import { getCategory } from '@/api/product'
import { ICategoryNode, ICategoryActive } from '@/interfaces/info'
import { ICategory } from '@/interfaces/product'
import Vue from 'vue'
import Vuex, { GetterTree, MutationTree, ActionTree } from 'vuex'
Vue.use(Vuex)

interface State {
  categoryList: ICategory[] | null;
  categoryTree: ICategoryNode[];
  active: ICategoryActive,
  categoryRouteHistory: Array<number| string | undefined> | null,
}

const getDefaultState = (): State => {
  return {
    categoryList: [],
    categoryTree: [],
    active: {
      activeCategory: null,
      activeSubCategory: null,
      activeProduct: null
    },
    categoryRouteHistory: []
  }
}
const state = getDefaultState()

const getters: GetterTree<State, any> = {
  categoryList (state: State) {
    return state.categoryList
  },
  categoryTree (state: State) {
    return state.categoryTree
  },
  active (state: State) {
    return state.active
  },
  categoryRouteHistory: state => state.categoryRouteHistory
}

const mutations: MutationTree<State> = {
  SET_CATEGORY_LIST (state: State, categoryList: Array<ICategory>) {
    state.categoryList = categoryList || []
    state.categoryTree = []
    for (const category of categoryList) {
      const categoryId = category.category_id.toString()
      const subCategoryIdsArray = category.category_list_name.map(c => {
        return { type: 'category', id: c.category_id.toString() }
      })
      const productIdsArray = category.product_list_name.content.map(p => {
        return { type: 'product', id: p.product_id.toString() }
      })
      state.categoryTree.push({ categoryId, childList: [...subCategoryIdsArray, ...productIdsArray] })
    }
  },
  SET_ACTIVE (state: State, active: ICategoryActive) {
    state.active = active
  },
  SET_ROUTE_HISTORY (state, payload) {
    if (state.categoryRouteHistory === null) {
      state.categoryRouteHistory = []
    }
    state.categoryRouteHistory = payload
  },
  RESET_ROUTE_HISTORY (state) {
    state.categoryRouteHistory = []
  }
}

const actions: ActionTree<State, any> = {
  async FETCH_CATEGORY_LIST ({ commit }) {
    try {
      const requestBody = {
        return_category_list: '1'
      }
      const { data } = await getCategory(requestBody)
      if (data.flag === 0) {
        const payload = data.data
        if (payload === undefined) { throw new Error('資料欄位錯誤') }
        commit('SET_CATEGORY_LIST', payload.category_list)
        return Promise.resolve()
      }
      return Promise.reject(data)
    } catch (error) {
      console.error(error)
      return Promise.reject(error)
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
